export const SubscribeCasting = (cast_id) => `/casting/${cast_id}`; 
































